import { render, staticRenderFns } from "./sideHole.vue?vue&type=template&id=6776503f&scoped=true&"
import script from "./sideHole.vue?vue&type=script&lang=js&"
export * from "./sideHole.vue?vue&type=script&lang=js&"
import style0 from "./sideHole.vue?vue&type=style&index=0&id=6776503f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6776503f",
  null
  
)

export default component.exports